module.exports = __webpack_public_path__ + "img/296f095.png";